<template>
    <div >
        <div class="t_search_box" style="margin-left: 20px;">
            <div class="t_search_select" >
                <img src="../../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.phone" placeholder="请输入手机号"  clearable />
            </div> 
            <div class="t_search_select" >
                <el-select v-model="searchdata.userId" @change="changesmh" clearable placeholder="扫码号" size="small"  >
                    <el-option style="height: auto;line-height: normal;padding:8px 32px 8px 20px" v-for="(item,index) in allpeolist.data" 
                        :key="index"
                        :value="item.wxid" :label="item.name" >
                        </el-option>
                </el-select>
            </div> 
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">申请时间：</span>
                <el-date-picker
                    v-model="sqtime.data"
                    @change="changesqTime"
                    size="small" 
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            <el-button @click="resetsearch" color="#F1F3F9" type="primary" style="margin-bottom: 10px;">重置</el-button>
        </div>
        <!-- 标题 -->
        <div class="t_title_box_f" style="justify-content:space-between;margin: 20px;">
            <div style="display: flex;align-items: center;">
                <div class="t_blue_line"></div>
                <div>添加列表</div>
            </div>
            <el-button @click="exportlist"  color="#4F46E5" type="primary">导出</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data"  style="width: 100%" >
            
            <el-table-column prop="index" align="center" label="序号"  >
                <template #default="scope">
                    {{ scope.$index+1 }}
                </template>
            </el-table-column>
            <el-table-column prop="phone" align="center" label="手机号"  />
            <el-table-column prop="wechatName" align="center" label="好友信息"  >
                <template #default="scope">
                    <img  style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                                :src="scope.row.wechatHeader" alt="">
                        {{scope.row.wechatName}}
                    
                   
                </template>
            </el-table-column>
            <el-table-column prop="userId" align="center" label="添加扫码号"  >
                <template #default="scope">
                    <img  style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                                :src="scope.row.userHeader" alt="">
                        {{scope.row.userName}}
                    
                   
                </template>
            </el-table-column>
            <el-table-column prop="sendTime" align="center" label="申请时间"  />
            <el-table-column prop="status" align="center" label="添加状态"  >
                <template #default="scope">
                    <span v-if="scope.row.status==0">
                        未发送
                    </span>
                    <span v-if="scope.row.status==1">
                        发送成功
                    </span>
                    <span v-if="scope.row.status==2">
                        已通过
                    </span>
                    <span v-if="scope.row.status==3">
                        发送失败
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="smsMes" align="center" label="验证信息"  />
            <el-table-column prop="sucessTime" align="center" label="添加成功时间"  />
            <el-table-column prop="remark" align="center" label="备注"  />
        </el-table>
    </div>
</template>
<script setup>

import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Tickets,Picture } from '@element-plus/icons-vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { recordlist } from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    getallpeolist()
    getlist()
})
//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    // work/bcDepartment 老接口已废弃
    // allpeoselect(_url2,{corp_id:$cookies.get("fanscorpId")}).then((response)=>{
    //     if (response.data.msg.code == 0) {
    //         // console.log(response.data.result)
    //         allpeolist.data = response.data.result
    //     }
    // })
}

//监听输入框
const searchinput = (e)=>{
    console.log(e)
    searchdata.phone = e
    getlist()
}
//修改扫码号
const changesmh = (e)=>{
    console.log(e)
    searchdata.userId = e
    getlist()
}
//执行时间
const sqtime = reactive({
    data:[]
})
//监听执行时间改变
const changesqTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.startTime = ''
        searchdata.endTime = ''
    }else{
        searchdata.startTime = e[0]
        searchdata.endTime = e[1]
    }
    getlist()
}
// 搜索
const searchdata = reactive({
    phone:'',
    userId:'',
    startTime:'',
    endTime:'',
    taskId:route.query.id
})
//重置
const resetsearch = ()=>{
    searchdata.phone = ''
    searchdata.status = ''
    searchdata.userId = ''
    searchdata.startTime = ''
    searchdata.endTime = ''
    sqtime.data = []
    getlist()
}
//导出列表
const exportlist = ()=>{
    var exportL = JSON.parse(JSON.stringify(searchdata));
    // exportL.taskId  = route.query.id
    exportL.corpId  = $cookies.get("fanscorpId")
    
    var str = '?'
    for (let key in exportL) {
        str=str+key+'='+exportL[key]+'&'
    }
    console.log( str.slice(0, -1))
    const a = document.createElement('a');
    a.setAttribute('download', '');
    a.setAttribute('href', _url2 + `/work/bcAddFriendTask/exportXlsApply`+ str.slice(0, -1)+'&addType='+route.query.addType);
    a.click();
}
//列表内容
const tableData = reactive({
    data:[]
})
//获取列表数据
const getlist = ()=>{
    recordlist(_url2,searchdata).then((response)=>{
        console.log('申请记录列表')
        console.log(response)
        tableData.data = response.data.result.records
    })
}
</script>
<style scoped>
:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_input_bg .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_textarea_nobod .el-textarea__inner)  {
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
</style>